











import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../../mixins";
import { FormatPagePropertyEditor } from "./contents";
import {
  FormatPageStructureEditor,
} from "../../../../../domain/editableFormat";

@Component({
  components: {
    FormatPagePropertyEditor,
  },
})
export default class FormatNewPagePropertyEditTool extends Mixins(FormatStructureEditableMixin, ModelEditableMixin) {
  editingPage: FormatPageStructureEditor = null;

  mounted(): void {
    this.editingPage = this.createNewPage(this.currentPage);
  }

  handleAdd(): void {
    this.addPage(this.editingPage);
    this.editingPage = this.createNewPage(this.editingPage);
  }
}
